<template>
    <v-expansion-panels
        :disabled="checking"
    >
        <v-expansion-panel
            id="summary-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('summary')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewSummary
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        HomeVantage™ Summary
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-summary/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
            id="deal-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('deal')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewLPP
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Deal Summary
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-deal/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
            id="upfront-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('upfront')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyMoreBenefitEstateFee
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Upfront Payment
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-upfront/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel
            v-if="!clientView"
            id="advisor-mobile-accordion"
        >
            <v-expansion-panel-header
                class="title-branding"
                @click="goTo('advisor')"
            >
                <div
                    class="d-flex justify-start align-center"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                        class="mr-2"
                        large
                    >
                        $mdiLegacyReviewAdvisor
                    </v-icon>
                    <h3
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Advisor WIIFM
                    </h3>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content
                class="no-padding-accordion-panel"
            >
                <v-card
                    class="pa-0"
                    flat
                >
                    <summary-advisor/>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import SummaryIcons from "./Tabs/Icons";
    import SummarySummary from "./Tabs/Summary";
    import SummaryDeal from "./Tabs/Deal";
    import SummaryAdvisor from "./Tabs/Advisor";
    import SummaryUpfront from "./Tabs/Upfront";

    import HomeVantageMixin from "../homevantage";

    export default {
        name: "My-Cover-Mobile-Accordion",

        components: {
            SummaryIcons,
            SummarySummary,
            SummaryDeal,
            SummaryAdvisor,
            SummaryUpfront
        },

        props: {
            'clientView': {
                type: Boolean,
                default: false,
            },
        },

        mixins: [
            HomeVantageMixin
        ],

        data() {
            return {}
        },

        methods: {
            goTo(location) {
                location = '#' + location + '-mobile-accordion';

                setTimeout(() => {
                    this.$vuetify.goTo(location, {
                        duration: 300,
                        offset: 0,
                        easing: 'easeInOutCubic',
                    });
                }, 300);
            }
        }
    }
</script>
